import Vue from 'vue'
import App from './App.vue'
import zh from "./common/zh.js"
import en from "./common/en.js"
import de from "./common/de.js"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import VueI18n from 'vue-i18n'
import http from "./common/https.js"
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
Vue.prototype.$http = http
Vue.config.productionTip = false
const messages = {
	en: en,
	zh: zh,
	de: de
}
Vue.use(ElementUI);
Vue.use(VueI18n)
// 通过选项创建 VueI18n 实例
if(window.localStorage.locale == 'zh' || window.localStorage.locale == 'de'){
	Vue.prototype.$locale = window.localStorage.locale
}else{
	Vue.prototype.$locale = 'en'
}
const i18n = new VueI18n({
	locale: Vue.prototype.$locale, // 设置地区
	messages, // 设置地区信息
})

new Vue({
	i18n,
	router,
	render: h => h(App),
}).$mount('#app')
